import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { UnsplashImage } from "../api/unsplash";
import * as t from "io-ts";
import { isUnsplashImage } from "./dimensions";
import { MediaInputValue, Image } from "@/types/media";

export const MediaUploadResponseV = t.type({
  attachment_id: t.number,
  url: t.string,
  alt: t.string,
  caption: t.string
});

export type MediaUploadResponse = t.TypeOf<typeof MediaUploadResponseV>;

// TODO - this function needs to return a proper value, not just want tha tmatches the type definition with the sizes hard-coded
export function getMediaInputValueFromMediaUploadResponse(
  response: MediaUploadResponse
): MediaInputValue {
  const image: Image = {
    id: response.attachment_id,
    filename: `downloaded-image-${response.attachment_id}.jpg`,
    url: response.url,
    alt: response.alt,
    caption: response.caption,
    type: "image",
    mime: "image/jpeg",
    sizes: {
      full: {
        width: 1200,
        height: 800,
        orientation: "landscape",
        url: response.url
      }
    },
    attributes: {}
  };
  
  return image;
}

export function shouldDownloadImageToMediaLibrary(
  image: UnsplashImage
): boolean {
  // unsplash wants to be hotlinked
  return !isUnsplashImage(image);
}

export async function downloadImageToMediaLibrary(
  imageUrl: string,
  image: UnsplashImage
): Promise<MediaUploadResponse | null> {
  try {
    const result = await makeWordPressAjaxRequest({
      action: "breakdance_download_external_image",
      dataToPost: {
        image_url: imageUrl,
        alt_text: image.alt_description || "",
        caption: image.description || "",
        filename: generateFilenameFromImage(image)
      },
      decoder: MediaUploadResponseV,
      friendlyName: "Download external image to media library"
    });

    if (result._tag === "Right") {
      return result.right;
    } else {
      console.error("Failed to download image to media library:", result.left);
      return null;
    }
  } catch (error) {
    console.error("Error downloading image to media library:", error);
    return null;
  }
}

function generateFilenameFromImage(image: UnsplashImage): string {
  let filename = "stock-image";

  if (image.alt_description) {
    filename = image.alt_description
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  } else if (image.description) {
    filename = image.description
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "-")
      .replace(/-+/g, "-")
      .replace(/^-|-$/g, "");
  }

  // Add image ID to ensure uniqueness
  filename = `${filename}-${image.id}`;

  const extension = "jpg";
  return `${filename}.${extension}`;
}
